import QRCode from 'qrcode';

/** Colores de la marca con contraste de lectura: módulos asfalto sobre blanco, esquinas en verde pizarra. */
const INK = '#16181D';
const GREEN = '#2F6B57';
const YELLOW = '#F2B90F';
const QUIET = 3; // módulos de margen

function isFinder(r: number, c: number, n: number): boolean {
  const inBox = (r0: number, c0: number) => r >= r0 && r < r0 + 7 && c >= c0 && c < c0 + 7;
  return inBox(0, 0) || inBox(0, n - 7) || inBox(n - 7, 0);
}

/**
 * SVG del QR con estilo generado 100 % en el navegador (el contenido puede ser un secreto, p. ej. TOTP):
 * puntos redondeados, esquinas en verde con redondeo leve y el isotipo al centro sobre blanco.
 * Esquinas con radio ≤ 0,5 módulo: con radios mayores el detector de OpenCV deja de encontrar el QR
 * (probado con OpenCV y WeChat; misma regla que la degradación de esquinas de R13.3).
 */
export function buildStyledQrSvg(value: string, withMark = true): string {
  {
    const qr = QRCode.create(value, { errorCorrectionLevel: withMark ? 'H' : 'M' });
    const n = qr.modules.size;
    const total = n + QUIET * 2;
    const markModules = withMark ? Math.round(n * 0.18) | 1 : 0; // impar para centrar
    const m0 = Math.floor((n - markModules) / 2);
    const inMark = (r: number, c: number) =>
      withMark && r >= m0 - 1 && r < m0 + markModules + 1 && c >= m0 - 1 && c < m0 + markModules + 1;

    const dots: string[] = [];
    for (let r = 0; r < n; r++) {
      for (let c = 0; c < n; c++) {
        if (!qr.modules.get(r, c) || isFinder(r, c, n) || inMark(r, c)) continue;
        dots.push(`M${c + QUIET + 0.5} ${r + QUIET + 0.06}a0.44 0.44 0 1 1 0 0.88a0.44 0.44 0 1 1 0-0.88`);
      }
    }
    const eye = (r0: number, c0: number) => {
      const x = c0 + QUIET;
      const y = r0 + QUIET;
      return (
        `<rect x="${x + 0.5}" y="${y + 0.5}" width="6" height="6" rx="0.5" fill="none" stroke="${GREEN}" stroke-width="1"/>` +
        `<rect x="${x + 2}" y="${y + 2}" width="3" height="3" rx="0.25" fill="${INK}"/>`
      );
    };
    let mark = '';
    if (withMark) {
      const x = m0 + QUIET;
      const s = markModules;
      const k = s / 32;
      mark =
        `<rect x="${x - 0.6}" y="${x - 0.6}" width="${s + 1.2}" height="${s + 1.2}" rx="${s * 0.3}" fill="#FFFFFF"/>` +
        `<g transform="translate(${x} ${x}) scale(${k})">` +
        `<rect width="32" height="32" rx="8" fill="${YELLOW}"/>` +
        `<path d="M7 12V7h5M20 7h5v5M7 20v5h5" fill="none" stroke="${INK}" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>` +
        `<path d="M10.5 16H21.5" fill="none" stroke="${INK}" stroke-width="5" stroke-linecap="round"/>` +
        `<circle cx="23.5" cy="23.5" r="2.3" fill="${INK}"/></g>`;
    }
    return (
      `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${total} ${total}" shape-rendering="geometricPrecision">` +
      `<rect width="${total}" height="${total}" rx="${total * 0.06}" fill="#FFFFFF"/>` +
      `<path d="${dots.join('')}" fill="${INK}"/>` +
      eye(0, 0) + eye(0, n - 7) + eye(n - 7, 0) + mark +
      `</svg>`
    );
  }
}
